import { Stepper3 } from '@/src/assets';

import { urlWithPublicPath } from '..';

export const SendEmailStepperImg = () => {
  return (
    <div className="flex h-full flex-col">
      <img alt="" src={urlWithPublicPath(Stepper3)} style={{ height: '300px' }} />
    </div>
  );
};
